import React, { FC, Dispatch, SetStateAction } from 'react';
import { useLocale, useTranslations } from 'next-intl';

import Skeleton from 'react-loading-skeleton';
import { Button, Checkbox, Radio } from 'rsuite';
import CustomAccordion from '@/components/ui/accordion';
import CustomSlider from '@/components/ui/slider';

import {
  AttributeTypes,
  SecondContentFilterProps,
} from './secondContent.types';
import styles from './category-second.module.scss';
import IconClose from '@/assets/icons/category-second-level/icon-close-circle.svg';
import { RADIO_BUTTONS } from './data';

const SecondContentFilter: FC<SecondContentFilterProps> = ({
  selectedProductIds,
  loading,
  totalCount,
  displayedProductsLength,
  productsVariantsLength,
  productsData,
  handleMiniCardClick,
  handleClearFilters,
  attributes,
  handleChangeAttribute,
  handleChangePrice,
  brandData,
  setIsAvailableForInstallment,
  isAvailableForInstallment,
  setIsOnSale,
  isOnSale,
  handleChangeBrands,
  percentDiscountAmount,
  onPercentDiscountAmount,
  discountAmounts,
}) => {
  const t = useTranslations('Components.category-second-content');
  const locale = useLocale();
  return (
    <div className={styles.filterWrapper}>
      {selectedProductIds.length > 0 && (
        <div className={styles.selectedWrapper}>
          <div className={styles.top}>
            <h3>{t('you-selected')}</h3>
            {loading ? (
              <span className={styles.skeletonForFilterCount}>
                <Skeleton />
              </span>
            ) : (
              <span>
                {selectedProductIds.length === 0
                  ? totalCount
                  : displayedProductsLength}{' '}
                {t('from')}{' '}
                {selectedProductIds.length === 0
                  ? totalCount
                  : productsVariantsLength}
              </span>
            )}
          </div>
          <div className={styles.selectedItems}>
            {selectedProductIds.map(id => {
              const product = productsData?.find(
                (edge: any) => edge.node.id === id
              )?.node;
              return (
                <div className={styles.item} key={id}>
                  <p>
                    {locale === 'ru'
                      ? product?.name
                      : (product?.variants?.[0]?.translation?.name ?? '')}
                  </p>
                  <Button
                    type="button"
                    className={styles.iconClose}
                    onClick={() => handleMiniCardClick(id)}
                  >
                    <IconClose />
                  </Button>
                </div>
              );
            })}
          </div>
          <Button
            type="button"
            className={styles.clearBtn}
            onClick={handleClearFilters}
          >
            {t('reset-filters')}
          </Button>
        </div>
      )}
      <div className={styles.filter}>
        <h3>{t('filters')}</h3>
        <div className={styles.accordion}>
          <CustomAccordion title={t('cost')}>
            <CustomSlider onChange={handleChangePrice} />
          </CustomAccordion>
        </div>
        <div className={styles.accordion}>
          <CustomAccordion title={t('status-product')}>
            <div className={styles.accordion}>
              <div
                onClick={() =>
                  setIsAvailableForInstallment(!isAvailableForInstallment)
                }
              >
                <Checkbox color="orange" checked={isAvailableForInstallment}>
                  {t('available-for-installment')}
                </Checkbox>
              </div>
              <div onClick={() => setIsOnSale(!isOnSale)}>
                <Checkbox color="orange" checked={isOnSale}>
                  {t('product-on-stock')}
                </Checkbox>
              </div>
            </div>
          </CustomAccordion>
        </div>
        <div className={styles.accordion}>
          <CustomAccordion title={t('product-on-discount')}>
            {RADIO_BUTTONS().map(
              (radio: {
                id: number;
                value: number | string;
                label: string;
              }) => (
                <div
                  key={radio.id}
                  className={styles.accordion}
                  onClick={() => onPercentDiscountAmount(radio.value)}
                >
                  <Radio
                    color="orange"
                    value={radio.value}
                    checked={percentDiscountAmount === radio.value}
                    disabled={!discountAmounts?.includes(radio.value as number)}
                  >
                    {radio.label}
                  </Radio>
                </div>
              )
            )}
          </CustomAccordion>
        </div>
        <div className={styles.accordion}>
          <CustomAccordion title={t('brand')}>
            {brandData?.brands?.edges.map(brand => (
              <div className={styles.accordion} key={brand?.node?.id}>
                <Checkbox
                  color="orange"
                  onChange={() => handleChangeBrands(brand?.node?.id)}
                >
                  {brand.node.name}
                </Checkbox>
              </div>
            ))}
            {/* <Link href={"#"} className={styles.link}>
                    Показать все <IconArrowRight />
                  </Link> */}
          </CustomAccordion>
        </div>
        {attributes?.map((attribute: any) => (
          <div key={attribute?.node.id} className={styles.accordion}>
            {attribute?.node.withChoices ? (
              <CustomAccordion
                title={
                  locale === 'ru'
                    ? attribute?.node.name
                    : (attribute?.node?.translation?.name as string)
                }
              >
                <div className={styles.accordion}>
                  {attribute?.node.choices?.edges.map(
                    (attr: AttributeTypes) => (
                      <div
                        key={attr.node.id}
                        onClick={() =>
                          handleChangeAttribute(attribute, attr.node)
                        }
                      >
                        <Checkbox
                          color="orange"
                          // checked={
                          //   selectedAttribute[0]?.values[0] == attr?.node?.slug
                          // }
                        >
                          {locale === 'ru'
                            ? attr.node.name
                            : attr.node.translation.name}
                        </Checkbox>
                      </div>
                    )
                  )}
                </div>
              </CustomAccordion>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecondContentFilter;
